







































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { store, StoreState } from "../../store";
import ComboboxConference from "../ComboboxConference.vue";

@Component({
  components: {
    ComboboxConference
  },
  computed: {
    ...mapState({
      conferencedata: (state: StoreState) => state.dashboard.ConferenceData
    })
  },
  methods: {
    isNumber: function(evt) {
      this.$data.errorAddPhone = false;
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        ((charCode > 47 && charCode < 58) || charCode === 44)
      ) {
        return true;
      } else {
        evt.preventDefault();
      }
    }
  }
})
export default class StartCall extends Vue {
  data() {
    return {
      closeImg: "img/icons/Extension_icon.png",
      isLoading: false,
      addPhone: "",
      addconference_status: false,
      conference_people: [],
      conference_people_list: [],
      errorConference_people: false,
      errorAddPhone: false
    };
  }

  async created() {
   
  }

  finalSelected(selectedArray) {
    this.$data.errorConference_people = false;
    this.$data.addconference_status = false;
    this.$data.conference_people = [];
    this.$data.conference_people_list = selectedArray
      .map(({ label }) => label)
      .join(", ");
    this.$data.conference_people = selectedArray.map(({ id }) => id);
    this.$data.conference_people = this.$data.conference_people.filter(function(
      element
    ) {
      return element !== undefined;
    });
  }

  closingModal() {
    this.$data.addPhone = "";
    (this as any).$children[0].resetStartCallModal();
    this.$emit('clicked', 'Bridge');
  }

  conferenceCall() {
    
    if(!this.$data.addPhone && this.$data.conference_people.length === 0) {
      this.$data.errorAddPhone = true;
      return;
    }
   // this.$data.isLoading = true;
    var ponenumners = this.$data.addPhone;
    var arr_extphone_number =
      ponenumners.length > 0 ? ponenumners.split(",") : [];
    var endpoints = this.$data.conference_people;
    endpoints.push(...arr_extphone_number);
    if (endpoints.length > 0) {
      var payload = {
        endpoints: endpoints,
        id: (this as any).conferencedata.id
      };
      this.$store.dispatch("inviteusers", payload).then(_ => {        
        this.$data.isLoading = false;
       
      });
      this.$data.addPhone=[];
       this.$data.conference_people=[];
      //  this["$iziToast"].success({
      //     // title: this.$data.conference_people_list.substring(0, this.$data.conference_people_list.length - 2),
      //     message: "You successfully invited people to this conference."
      //   });
        this.closingModal();

    }
  }
}
